export default function (): void {
  const sortEl = document.getElementById('dashboard_filters_sort')

  if (!sortEl) {
    return
  }

  sortEl.addEventListener('change', function () {
    const form = document.getElementById('dashboard-form') as HTMLFormElement | null

    form?.requestSubmit()
  })
}
